import { render, staticRenderFns } from "./AuthValidateAccount.vue?vue&type=template&id=5b421c2a"
import script from "./AuthValidateAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthValidateAccount.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports